import React, { useEffect, useState } from 'react';
import { InputNumber, Spin, Table, Typography } from 'antd';
import { getOpsTaxas } from '../../services/opsService';
import { getAdminUrl } from '../../services/apiService';

const { Title } = Typography;

const formatCurrency = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default function OpsTaxasPage() {
  const [loading, setLoading] = useState(true);
  const [taxas, setTaxas] = useState([]);
  const [simuladorValor, setSimuladorValor] = useState(17.9);

  useEffect(() => {
    getOpsTaxas().then((data) => {
      setTaxas(data.taxas || []);
      setLoading(false);
    });
  }, []);

  if (loading) return <Spin size="large" />;

  const columns = [
    { title: 'Forma', dataIndex: 'label', key: 'label' },
    { title: 'Taxa %', dataIndex: 'taxa_percentual', key: 'taxa_percentual', render: (v) => `${v}%` },
    { title: 'Taxa fixa', dataIndex: 'taxa_fixa', key: 'taxa_fixa', render: formatCurrency },
    { title: 'Volume mês (bruto)', dataIndex: 'volume_mes_bruto', key: 'volume_mes_bruto', render: formatCurrency },
    { title: 'Volume mês (líquido)', dataIndex: 'volume_mes_liquido', key: 'volume_mes_liquido', render: formatCurrency },
    { title: 'Taxa estimada mês', dataIndex: 'taxa_estimada_mes', key: 'taxa_estimada_mes', render: formatCurrency },
    { title: 'Transações mês', dataIndex: 'transacoes_mes', key: 'transacoes_mes' },
  ];

  return (
    <div>
      <Title level={3}>Taxas por forma de pagamento</Title>
      <p style={{ color: '#666' }}>
        Edite as taxas no{' '}
        <a href={`${getAdminUrl()}assinaturas/taxaformapagamento/`}>Django Admin</a>
        {' '}(Taxas por forma de pagamento).
      </p>
      <Table rowKey="billing_type" columns={columns} dataSource={taxas} pagination={false} />
      <div className="ops-panel" style={{ marginTop: 24 }}>
        <Title level={5}>Simulador</Title>
        <InputNumber min={0} step={0.01} value={simuladorValor} onChange={setSimuladorValor} addonBefore="R$" />
        <div style={{ marginTop: 16 }}>
          {taxas.filter((t) => t.ativo).map((t) => {
            const bruto = Number(simuladorValor || 0);
            const liquido = bruto - (bruto * t.taxa_percentual / 100) - t.taxa_fixa;
            return (
              <p key={t.billing_type}>
                <strong>{t.label}:</strong> líquido estimado {formatCurrency(Math.max(liquido, 0))}
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
}
